import axios from "axios";

export const axiosResponseInterceptor = axios.interceptors.response;